class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.isLoading = false;
    this.observer = null;

    this.addEventListener('click', this.onClickHandler.bind(this));

    if (this.dataset.trigger == 'infinite') {
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
        rootMargin: '0px 0px 900px 0px',
        threshold: 0.01
      });
      this.observer.observe(this);
    }
  }

  onClickHandler() {
    if (this.isLoading || this.classList.contains('loading') || this.classList.contains('disabled')) return;

    const url = this.dataset.url;
    if (!url) return;

    this.isLoading = true;
    this.classList.add('loading');
    this.classList.add('disabled');
    this.setAttribute('aria-busy', 'true');

    InfiniteScroll.renderSectionFromFetch(url)
      .catch((e) => {
        console.error(e);
        this.classList.remove('disabled');
      })
      .finally(() => {
        this.isLoading = false;
        this.classList.remove('loading');
        this.removeAttribute('aria-busy');
      });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.onClickHandler();
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  static renderSectionFromFetch(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(response => response.text())
      .then((responseText) => {
        const parsedDocument = new DOMParser().parseFromString(responseText, 'text/html');
        InfiniteScroll.renderPagination(parsedDocument);
        InfiniteScroll.renderProductGridContainer(parsedDocument);
      });
  }

  static renderPagination(parsedDocument) {
    const container = document.getElementById('ProductGridContainer').querySelector('.pagination-wrapper');
    const pagination = parsedDocument.getElementById('ProductGridContainer')?.querySelector('.pagination-wrapper');

    if (!container) return;

    if (pagination) {
      container.innerHTML = pagination.innerHTML;
    }
    else {
      container.remove();
    }
  }

  static renderProductGridContainer(parsedDocument) {
    const container = document.getElementById('product-grid');
    const products = parsedDocument.getElementById('product-grid');

    if (!container || !products) return;

    const appendedItems = Array.from(products.children);
    const fragment = document.createDocumentFragment();

    appendedItems.forEach((item) => {
      item.classList.add('infinite-scroll-item-enter');
      fragment.appendChild(item);
    });

    container.appendChild(fragment);

    requestAnimationFrame(() => {
      appendedItems.forEach((item, index) => {
        window.setTimeout(() => {
          item.classList.remove('infinite-scroll-item-enter');
        }, index * 35);
      });
    });

    /* Notify filters that new products were loaded */
    document.dispatchEvent(new CustomEvent('infinite-scroll:loaded'));
  }
}
customElements.define('infinite-scroll', InfiniteScroll);
